<template>
    <div class="news-wrap">
        <!--<<div class="news-chanel">
            <div 
            :class="chanel.status ? 'news-chanel-item news-chanel-item-active' : 'news-chanel-item'" 
            v-for ="(chanel,index) in chanels" :key="index" @click="setChannel(index)">
                <div class="news-chanel-title">
                    {{chanel.title}}
                </div>
                <img :src="chanel.img">
            </div>
        </div>-->
        <div class="news"
            v-for="(item, index) in getNews" :key="index">
            <div class="news_title">
                <a :href="item.url" target="_blank">{{item.title}}</a>
            </div>
            <div class="news_img">
                <img :src= "item.urlToImage" >
            </div>
            <div class="news_content">
                <p>{{item.description}}</p>
                <span>{{$datef(item.publishedAt)}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { setTimeout } from 'timers';
export default {
    data() {
        return {
            news:null,
            chanels: [
                {
                    title:'РБК',
                    img:require('../../assets/img/rbk_logo.png'),
                    status:true,
                    method:'https://newsapi.org/v2/top-headlines?sources=rbc&apiKey=4e87afc5b31b42e594540338d355f7ce'
                },
                {
                    title:'Lenta.ru',
                    img:require('../../assets/img/lentaru_logo.png'),
                    status:false,
                    method:'https://newsapi.org/v2/top-headlines?sources=lenta&apiKey=4e87afc5b31b42e594540338d355f7ce'
                },
                {
                    title:'Financial Times',
                    img:require('../../assets/img/ft_logo.png'),
                    status:false,
                    method:'https://newsapi.org/v2/top-headlines?sources=financial-times&apiKey=4e87afc5b31b42e594540338d355f7ce'
                },
                {
                    title:'Crypto Coins',
                    img:require('../../assets/img/cc_logo.png'),
                    status:false,
                    method:'https://newsapi.org/v2/top-headlines?sources=crypto-coins-news&apiKey=4e87afc5b31b42e594540338d355f7ce'
                }
            ]
        }
    },
    methods: {
        setChannel(index) {
            this.$store.dispatch('news/requestNews',this.chanels[index].method);
            for(let i = 0; i < this.chanels.length; i++)
            {
                if(i == index)
                this.chanels[i].status = true
                else
                this.chanels[i].status = false
            }
        }
    },
    computed: {
        ...mapGetters ({
            getNews:'news/getNews',
        })
    },
    mounted() {
        this.$store.dispatch('news/requestNews');
        setTimeout(()=> {
            this.$store.dispatch('news/requestNews');
        }, 180000)
    },
}
</script>
<style lang="less" scoped>
.news {
    display: block;
    max-width: 360px;
    overflow: hidden;
    padding: 8px 12px;
    &-wrap {
        position: relative;
        width: 360px;
    }
    &_title {
        display: block;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.54;
        letter-spacing: 0.4px;
        text-align: left;
        color: #ffffff;
        text-decoration: none;
        margin-bottom:8px;
    }
    &_content {
        display: block;
        font-family: Arimo;
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.54;
        letter-spacing: 0.4px;
        text-align: left;
        color: #a1b7cc;
        padding-bottom: 4px;
        border-bottom: 1px solid #00ffd0;
        span {
            color:#fff;
            width:100%;
            text-align: right;
            float: right;
            margin-top: 4px;
        }
    }
    &-chanel {
        background: #374b62;
        overflow: hidden;
        height: 40px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: sticky;
        top:0;
        &-item {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            height: 100%;
            &-active {
               background: #3d536b; 
            }
        }
        &-title {
            font-family: Arimo;
            font-size: 10px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            text-transform: uppercase;
        }
        img {
            height: 13px;
            width:13px;
            margin-left: 4px;
        }
    }
}
</style>

